import React from 'react';

import { connect } from 'react-redux';

import { getAccountIdFromUuid } from 'src/selectors/user-selectors';
import { BucketState } from 'src/types/state';

import { Props as CommentComponentProps } from '../components/Comment';

type Props = CommentComponentProps & {
  renderComment: (props: CommentComponentProps) => JSX.Element;
};

const mapStateToProps = (state: BucketState, ownProps: Props) => {
  const commentAuthorAccountId = getAccountIdFromUuid(
    state,
    ownProps.comment.createdBy.id
  );
  return {
    ...ownProps,
    commentAuthorAccountId,
  };
};

class CommentContainer extends React.Component<Props, {}> {
  render() {
    const { renderComment, ...otherProps } = this.props;

    return renderComment({
      ...otherProps,
    });
  }
}

export default connect(mapStateToProps)(CommentContainer as any);
